import numeral from 'numeral';

// locale FR pour les nombres
numeral.register('locale', 'fr', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème';
  },
  currency: {
    symbol: '€'
  }
});

// switch between locales
numeral.locale('fr');

/**
 *
 * @param number
 * @param precision
 * @returns {string} number formatté natif (en)
 */
const round = function (number, precision) {
  let formattedNumber = number;
  if (number || number === 0) {
    number = number.toString().replace(/\.|,/g, '.');
    formattedNumber = Number.parseFloat(number).toFixed(precision);
  }
  return formattedNumber;
};

/**
 *
 * @param number
 * @param precision
 * @returns {string} nombre formatté en français
 */
const formatDecimal = function (number, arg1, arg2) {
  if (arg2 === undefined) {
    const precision = arg1 === undefined ? 2 : arg1;
    return (number || number === 0) ? round(number, precision).replace(/\./g, ',') : number;
  } else {
    const precisionMax = arg2;
    const precisionMin = arg1;

    const precisionRegExp = RegExp('^(\\d+,\\d{0,' + precisionMin + '}[1-9]*?)0*$');

    return (number || number === 0) ? round(number, precisionMax).replace(/\./g, ',').replace(precisionRegExp, '$1').replace(/,$/, '') : number;
  }
};

/**
 *
 * @param number
 * @returns {string} nombre formatté en français
 */
const formatInteger = function (number) {
  const nombreFormatte = round(number, 0);
  return nombreFormatte;
};

const split = function (value) {
  return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : value;
};

/**
 * Arrondi un nombre s'il est présent et supérieur à zéro.
 *
 * @param number nombre ou null
 * @param precision nombre de décimal
 * @return {string} nombre arrondi ou '-'
 */
const roundValueIfPresent = function (number, precision) {
  let value = '-';
  if (number && number > 0) {
    value = round(number, precision);
  }
  return value;
};

export default {
  round,
  formatDecimal,
  formatInteger,
  split,
  roundValueIfPresent
};
